module.exports = "../fonts/n-a.woff";


//////////////////
// WEBPACK FOOTER
// ./src/main/script/komodo/fonts/n-a.woff
// module id = UOgc
// module chunks = 1